module.exports = __webpack_public_path__ + "img/hero.7305858c.png";